import { Columns } from '@shared/interfaces/table/column-config';
import { MeterDto } from '@app/api/nts';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { AppendDecimalsCellComponent } from '@shared/components/table/cells/append-decimals-cell/append-decimals-cell.component';

export const meterProductMasterData: Columns<MeterDto>[] = [
  {
    title: 'vendor.name',
    key: 'vendor.name',
  },
  {
    title: 'model.name',
    key: 'model.name',
  },
  {
    title: 'model.productionYear',
    key: 'productionYear'
  },
  {
    title: 'model.numberOfDigits',
    key: 'numberOfDigits',
    cellRenderer: AppendDecimalsCellComponent,
    cellRendererParams: {
      digits: 4
    }
  },
  {
    title: 'model.readingType',
    key: 'meterReadingType',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meter.readingTypes.NotSpecified',
      accumulated: 'meter.readingTypes.Accumulated',
      balanced: 'meter.readingTypes.Balanced',
      none: 'meter.readingTypes.None'
    }
  },
]
